export var WebhookEventEnum;
(function (WebhookEventEnum) {
    // Workflow
    WebhookEventEnum["WORKFLOW_CREATED"] = "workflow.created";
    WebhookEventEnum["WORKFLOW_UPDATED"] = "workflow.updated";
    WebhookEventEnum["WORKFLOW_DELETED"] = "workflow.deleted";
    WebhookEventEnum["WORKFLOW_PUBLISHED"] = "workflow.published";
    // Message
    WebhookEventEnum["MESSAGE_SENT"] = "message.sent";
    WebhookEventEnum["MESSAGE_FAILED"] = "message.failed";
    WebhookEventEnum["MESSAGE_DELIVERED"] = "message.delivered";
    WebhookEventEnum["MESSAGE_SEEN"] = "message.seen";
    WebhookEventEnum["MESSAGE_READ"] = "message.read";
    WebhookEventEnum["MESSAGE_UNREAD"] = "message.unread";
    WebhookEventEnum["MESSAGE_ARCHIVED"] = "message.archived";
    WebhookEventEnum["MESSAGE_UNARCHIVED"] = "message.unarchived";
    WebhookEventEnum["MESSAGE_SNOOZED"] = "message.snoozed";
    WebhookEventEnum["MESSAGE_UNSNOOZED"] = "message.unsnoozed";
    WebhookEventEnum["MESSAGE_DELETED"] = "message.deleted";
    // Preference
    WebhookEventEnum["PREFERENCE_UPDATED"] = "preference.updated";
    // Email Inbound
    WebhookEventEnum["EMAIL_RECEIVED"] = "email.received";
})(WebhookEventEnum || (WebhookEventEnum = {}));
export var WebhookObjectTypeEnum;
(function (WebhookObjectTypeEnum) {
    WebhookObjectTypeEnum["WORKFLOW"] = "workflow";
    WebhookObjectTypeEnum["MESSAGE"] = "message";
    WebhookObjectTypeEnum["PREFERENCE"] = "preference";
    WebhookObjectTypeEnum["EMAIL_INBOUND"] = "email_inbound";
})(WebhookObjectTypeEnum || (WebhookObjectTypeEnum = {}));
//# sourceMappingURL=webhook-event.enum.js.map